module.exports = __webpack_public_path__ + "assets/img/home_bg.70e2e863.png";